module.exports = __webpack_public_path__ + "img/MapThumb_Oasis.8e79cea3.webp";